/** Phase 18 — customerInvoices lesen. */

import { listAggregateCustomerInvoices } from '../infrastructure/storage/domainAggregateStore';
import { listEntityCustomerInvoices } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'customerInvoices',
  listAggregate: listAggregateCustomerInvoices,
  listEntity: listEntityCustomerInvoices,
  idKeys: ['id', 'invoiceNumber']
});

export const readCustomerInvoicesFromMergedBlob = source.readFromMergedBlob;
export const readCustomerInvoicesFromBestSource = source.readFromBestSource;
export const refreshCustomerInvoicesReadCache = source.refreshReadCache;
export const getCachedCustomerInvoicesRead = source.getCachedRead;
export const clearCustomerInvoicesReadCache = source.clearReadCache;
export const readCustomerInvoicesSyncForBusiness = source.readSyncForBusiness;
